import React from 'react';

/**
 * Static SVG stand-in for the "Text Section" (StandardHeaderText) block, shown on
 * its palette card in the v2 editor: a single card with a heading and two
 * paragraphs of prose. Wireframe style, matching {@link ImageCardPreviewGraphic}
 * and {@link LeftRightListPreviewGraphic}; scales with its container via the
 * viewBox.
 */

const CARD_X = 30;
const CARD_Y = 30;
const CARD_W = 1120;
const PAD = 28;
const INNER_W = CARD_W - PAD * 2;
const BAR_H = 14;
const BAR_STEP = 30;

const HEADING_BASELINE = CARD_Y + PAD + 26;
const P1_TOP = HEADING_BASELINE + 20;
const P1_ROWS = [1, 1, 0.55];
const P2_TOP = P1_TOP + P1_ROWS.length * BAR_STEP + 26;
const P2_ROWS = [1, 1, 1, 0.48];

const CARD_H = P2_TOP + (P2_ROWS.length - 1) * BAR_STEP + BAR_H + PAD - CARD_Y;
const VIEW_H = CARD_Y + CARD_H + 16;

function Paragraph({ top, rows }: { top: number; rows: number[] }) {
  return (
    <>
      {rows.map((ratio, index) => (
        <rect
          key={index}
          x={CARD_X + PAD}
          y={top + index * BAR_STEP}
          width={INNER_W * ratio}
          height={BAR_H}
          rx={BAR_H / 2}
          fill={ratio < 1 ? '#D8DBDE' : '#C7CBD0'}
        />
      ))}
    </>
  );
}

export default function TextSectionPreviewGraphic() {
  return (
    <svg
      viewBox={`0 0 1180 ${VIEW_H}`}
      width="100%"
      role="img"
      aria-label="Text Section block: a card with a heading and two paragraphs"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <rect
        x={CARD_X}
        y={CARD_Y}
        width={CARD_W}
        height={CARD_H}
        rx="20"
        fill="#F1F2EF"
        stroke="#E4E4E0"
      />
      <text
        x={CARD_X + PAD}
        y={HEADING_BASELINE}
        fontFamily="Manrope, system-ui, -apple-system, sans-serif"
        fontSize="30"
        fontWeight="700"
        fill="#20423A"
      >
        Text Section
      </text>
      <Paragraph top={P1_TOP} rows={P1_ROWS} />
      <Paragraph top={P2_TOP} rows={P2_ROWS} />
    </svg>
  );
}
